import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/filing-review/global-settings/{id}']['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];
type Output = ThisApi['response'];

const updateGlobalSettings = async ({ id, ...body }: Input): Promise<Output> => {
  const path = buildPath<ThisApi>('/filing-review/global-settings/{id}', { id });
  const response = await noodleApiClient.put(path, body);
  return response.data;
};

export default updateGlobalSettings;
